module.exports = __webpack_public_path__ + "img/tapang-outline-black.6c9df6c7.png";